import Vue from 'vue';
import '@/assets/style/scss/app.scss'; // Global Styles (Actual styles)
import 'video.js/dist/video-js.css';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import '@fortawesome/fontawesome-free/css/all.css';
import { Buffer } from "buffer";
// PLUGINS
import './plugins/prototype-extensions';
import './plugins/auth';
import './plugins/piri/axios-client';
import './plugins/piri/content-transform';
import './plugins/piri/error';
import './plugins/vee-validate';
import './plugins/froala';
import './plugins/quill';
import './plugins/ckeditor';
import 'piri/utils';

import { initializeSentry } from '@/plugins/sentry';
import App from './App.vue';
import store from './store/index';
import router from './router/index';
import i18n from './plugins/piri/vue-lang';
import vuetify from './plugins/vuetify';
import { setDefaultSiteId } from './helpers/site';

window.Buffer = Buffer;
Vue.config.productionTip = false;

initializeSentry();

setDefaultSiteId();

window.app = new Vue({
  el: '#pho',
  router,
  store,
  i18n,
  vuetify,
  created() {
    this.initialized = true;
  },
  render: h => h(App),
});
